import { LocalizedStrict } from "../../../../../localization/components/AppLocalized"
import { FormikDropdown, FormikTextField } from "../../../../../../shared/components/forms/Formik"
import { MenuItem, Stack } from "@mui/material"
import { CountryCode, EntityFormValues } from "../../supportEntitiesTypes"
import { makeStyles } from "tss-react/mui"

const useStyles = makeStyles()(() => ({
    textField: {
        width: "25%",
        minWidth: "10rem",
    },
}))

export function AddressContent() {
    const { classes } = useStyles()

    return (
        <>
            <LocalizedStrict id="support-create-entity-country-label" attrs={{ label: true }}>
                <FormikDropdown<EntityFormValues> fullWidth label="Country" name="countryCode">
                    <MenuItem value={CountryCode.DK}>
                        <LocalizedStrict id="support-create-entity-dropdown-country-denmark">
                            <span>Denmark</span>
                        </LocalizedStrict>
                    </MenuItem>
                </FormikDropdown>
            </LocalizedStrict>
            <LocalizedStrict id="support-create-entity-address1-label" attrs={{ label: true, placeholder: true }}>
                <FormikTextField<EntityFormValues> name="address1" label="Address line 1" fullWidth />
            </LocalizedStrict>
            <LocalizedStrict id="support-create-entity-address2-label" attrs={{ label: true, placeholder: true }}>
                <FormikTextField<EntityFormValues> name="address2" label="Address line 2" fullWidth />
            </LocalizedStrict>
            <Stack direction="row" gap="1.25rem">
                <LocalizedStrict id="support-create-entity-postal-code-label" attrs={{ label: true }}>
                    <FormikTextField<EntityFormValues>
                        className={classes.textField}
                        name="postalCode"
                        label="Postal code"
                    />
                </LocalizedStrict>
                <LocalizedStrict id="support-create-entity-city-label" attrs={{ label: true }}>
                    <FormikTextField<EntityFormValues> name="city" label="City" fullWidth />
                </LocalizedStrict>
            </Stack>
        </>
    )
}
